import { Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

export const DownloadButton = ({ onClick, title }) => {
  return (
    <Button
      variant="outlined"
      color="#e62552"
      onClick={onClick}
      startIcon={<DownloadIcon />}
      sx={{ fontFamily: 'Montserrat, serif !important' }}
    >
      {title}
    </Button>
  );
};
